import "./App.css";
import Board from "./components/Board";

function App() {
  return (
    <div className="App">
      <Board />
    </div>
  );
}

export default App;
